import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import App from '@/App.vue';
import i18n from '@/i18n';
import router from '@/router';
import store from '@/store';
import config from '@/config';
import bricodes from '@/bricodes';

const isInProductionEnvironment = process.env.NODE_ENV === 'production';

Vue.config.productionTip = false;

Vue.use(VueAnalytics, {
  router,
  id: config.analyticsId,
  autoTracking: {
    exception: isInProductionEnvironment,
  },
});

new Vue({
  i18n,
  router,
  store,
  bricodes,
  render: h => h(App),
}).$mount('#app');
